// services/api.js - Frontend API Integration
import axios from "axios";

const API_URL =
  import.meta.env.VITE_NETWORKLIST_API_URL || "https://dashboard.lono.co.in/api/networklist";

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Network Member API
export const networkMemberAPI = {
  // ✅ Get all network members
  getAll: async () => {
    try {
      const response = await api.get("/network-members");
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ✅ Get single network member by its document ID
  getById: async (id) => {
    try {
      const response = await api.get(`/network-members/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ✅ Get all network members created by a specific user
  getByUser: async (userId) => {
    try {
      const response = await api.get(`/network-members/user/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ✅ Create new network member
  create: async (memberData) => {
    try {
      const response = await api.post("/network-members", memberData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ✅ Update network member
  update: async (id, data) => {
    try {
      const response = await api.put(`/network-members/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // ✅ Delete network member
  delete: async (id) => {
    try {
      const response = await api.delete(`/network-members/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};
